<template>
  <div class="form-container">
    <el-form
    label-position="top"
    label-width="80px"
    ref="form"
    :model="form"
    :rules="rules">
      <el-row>
        <el-col :span="12" style="padding-right: 30px">
          <el-form-item label="企业名称（全称）" prop="enterprise_name">
            <el-input v-model="form.enterprise_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称" prop="product_name">
            <el-input v-model="form.product_name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" >
          <el-form-item label="企业营业执照" prop="business_license">
            <el-upload
              ref="business"
              class="upload-demo"
              name ='file'
              accept = '.jpg,.png'
              :action="uploadAction"
              :multiple = "false"
              :limit="1"
              :on-success="busineseSuccess"
              :on-remove="busineseRemove">
              <div class="upload-box">
                <el-button slot="trigger" size="small"  class="upload-button">选取文件<i class="el-icon-upload el-icon--right"></i></el-button>
                <p class="upload-message">只能上传jpg / png文件，不超过5M</p>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品软著" prop="product_software">
             <el-upload
             ref="product"
              class="upload-demo"
              name ='file'
              accept = '.jpg,.png'
              :action="uploadAction"
              :multiple = "false"
              :limit="1"
              :on-success="productSuccess"
              :on-remove="productRemove">
              <div class="upload-box">
                <el-button slot="trigger" size="small"  class="upload-button">选取文件<i class="el-icon-upload el-icon--right"></i></el-button>
                <p class="upload-message">只能上传jpg / png文件，不超过5M</p>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="相关联系人" prop="user_name" class="user-name">
        <el-input v-model="form.user_name"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱（企业邮箱）" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="mobile">
        <el-input v-model="form.mobile"></el-input>
      </el-form-item>
      <el-form-item label="公司地址（省市县门牌号）" prop="address">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item>
        <p class="submit-message">条件:必须接受集成联盟提供的一种能力。</p>
        <el-button class="submit-button" type="primary" @click="submitForm">提交申请</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import md5 from 'md5'
import { joinUs } from '@/api/api'
export default {
  name: 'ApplyForm',
  data () {
    var validate = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('此字段不能为空'))
        } else {
          callback()
        }
      }
      const fileValid =  (rule,value,cb) =>{
        if(!this.canSubmitObj[rule.field]){
          cb(new Error('文件提交错误，请移除文件重新提交!'))
        }
        cb()

      }
      const emailValidate = (rule, value, callback) => {
        // const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
        const reg = /^\w[-\w.+]*@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
        if(value === '') {
          callback(new Error('请填写邮箱'))
        } else if(!reg.test(value)) {
          callback(new Error('邮箱格式错误'))
        }else {
          callback()
        }
      }
      const phoneValidate = (rule, value, callback) => {
        const reg = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][0-9]))[0-9]{8}$/
        if(value === '') {
           callback(new Error('请填写手机号'))
        } else if(!reg.test(value)) {
          callback(new Error('手机号格式错误'))
        }else {
          callback()
        }
      }
      const addressValidate = (rule, value, callback) => {
        if(value === '') {
           callback(new Error('请输入公司地址'))
        } else if(value.length > 120) {
          callback(new Error('公司地址长度不能超过120字符'))
        }else {
          callback()
        }
      }
    return {
      canSubmitObj:{
        business_license:true,
        product_software:true,
      },//是否可以提交
      test: '',
      form: {
        enterprise_name: '',
        product_name: '',
        business_license: '',
        product_software: '',
        user_name: '',
        email: '',
        mobile: '',
        address: '',
      },
      // ${process.env.VUE_APP_BASE_URL} http://10.249.192.102:8000
      uploadAction: `/public/upload`,
      rules: {
        enterprise_name: [
           {  message: '请输入企业名称', trigger: 'blur' ,validator: validate },
        ],
        product_name: [
          {  message: '请输入产品名称', trigger: 'blur', validator: validate },
        ],
        business_license: [
            { trigger: 'change', validator: fileValid },
        ],
        product_software: [
           { trigger: 'change', validator: fileValid },
        ],
        user_name: [
            {  message: '请输入相关联系人', trigger: 'blur' ,validator: validate },
        ],
        email: [
           {   trigger: 'blur' ,validator: emailValidate },
        ],
        mobile: [
          {   trigger: 'blur',validator: phoneValidate  },
        ],
        address: [
          {   trigger: 'blur',validator: addressValidate  },
        ]
      }
    }
  },
  methods: {
    busineseRemove (file) {
      this.form.business_license = ''
      this.canSubmitObj.business_license = true
      this.$refs.form.validateField('business_license')
    },
    productRemove(file) {
      this.form.product_software = ''
      this.canSubmitObj.product_software = true;
      this.$refs.form.validateField('product_software')
    },
    /**
     * @description 营业执照上传成功的钩子
     * @param {any} response:文件上传成功后端返回的数据
     * @param {File} file:当前上传的文件
    */
    busineseSuccess (response, file) {
      const isValid = response.status === 10000
      this.canSubmitObj.business_license = isValid
      this.$refs.form.validateField('business_license')
      if(!isValid)return this.$message.error(response.message);
      const { data: { upload_filename }} = response
      this.form.business_license = upload_filename
    },
    /**
     * @description 产品软著上传成功的钩子
     * @param {any} response:文件上传成功后端返回的数据
     * @param {File} file:当前上传的文件
    */
    productSuccess (response, file) {
      const isValid = response.status === 10000
      this.canSubmitObj.product_software = isValid
      this.$refs.form.validateField('product_software')
      if(!isValid)return this.$message.error(response.message);
      const { data: { upload_filename } } = response
      this.form.product_software = upload_filename
    },
    /**
     * @description 处理sign参数，将参数以&符号拼接
     * @return {string} md5后的表单参数
    */
    handleParams () {
      let str = ''
      const fileds = Object.keys(this.form).sort()
      for ( const key of fileds) {
        if( Reflect.has( this.form, key)) {
          if(key === 'sign') continue
          str += `${key}=${this.form[key]}&`;
        }
      }
      return md5(str.substring(0, str.length - 1))
    },
    // 提交表单
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if( !this.form.product_software || !this.form.business_license ) {
            this.$message({
              message: '未上传营业执照或产品软著!',
              type: 'error'
            })
            return false;
          }
          // 存储MD5后的字符串
          this.form.sign = this.handleParams();
          joinUs(this.form).then(res => {
            const { status, message } = res
            if(status === 10000) {
              this.$message({
                message: '提交成功!',
                type: 'success'
              })
              this.$refs.form.resetFields()
              this.$refs.business.clearFiles()
              this.$refs.product.clearFiles()
            } else {
               this.$message({
                 message,
                 type: 'error'
               })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-form--label-top{
    .el-form-item__label {
      float: left;
    }
  }
  /deep/.el-upload-list__item:first-child{
    margin-top: 0;
  }
  /deep/.el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start !important;
    max-height: 60px;
    .el-input {
      height: 36px;
      margin-top: 20px;
      .el-input__inner {
        height: 36px;
      }
    }
    .el-form-item__label {
      font-size: 14px;
      height: 20px;
      padding-top: 5px;
    }
  }
  .user-name {
    margin-top: 30px;
  }
  .form-container {
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
    border-top: 3px solid #0044cc;
    padding: 40px;
    max-height: 690px;
    min-height: 690px;
    .upload-box {
      display: flex;
      justify-content: flex-start;
      margin: 25px 0 0  -62px;
      .upload-button {
        margin-right: 4px;
      }
      .upload-message {
        color: #CCCCCC;
        font-size: 12px;
      }
    }

    .submit-message {
      text-align: left;
      color: #999;
      font-size: 14px;
      margin-top: 5px;
    }
    .submit-button {
      width: 240px;
      height: 40px;
      margin-top: 20px;
      background-color: #0044CC;
      border-radius: 0;
    }
  }
</style>
